import React, { useEffect, useState } from 'react';
import SelectBox from 'devextreme-react/select-box';

import {
  Chart,
  Series,
  ArgumentAxis,
  CommonSeriesSettings,
  CommonAxisSettings,
  Grid,
  Export,
  Legend,
  Margin,
  Tooltip,
  Label,
  Format,
} from 'devextreme-react/chart';
import CardQuick from '../../components/Card';
import { Box, Button, Typography } from '@mui/material';
import { dashboardService } from "../../services";
import { useNavigate } from 'react-router-dom';


const ValidationChart = ({ locationId }) => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);

  useEffect(() => {
    dashboardService.getValidations(locationId).then((data) => {
      setData(data);
    }).catch(() => {

    })

  }, [locationId])
  return (
    <Box>
      <CardQuick>
        <Typography variant="h3">Validações</Typography>
        <Chart
          palette="Violet"
          dataSource={data}
          style={{ height: '300px' }}
        >
          <CommonSeriesSettings
            argumentField="Month"
            type={'spline'}
          />
          <CommonAxisSettings>
            <Grid visible={true} />
          </CommonAxisSettings>
          <Series
            valueField={'total'}
            name={'Month'} />
          <Margin bottom={20} />
          <ArgumentAxis
            allowDecimals={false}
            axisDivisionFactor={60}
          >
            <Label>
              <Format type="decimal" />
            </Label>
          </ArgumentAxis>
          <Legend
            verticalAlignment="top"
            horizontalAlignment="right"
            visible={false}
          />
          <Tooltip enabled={true} />
        </Chart>
      </CardQuick>
      <Box sx={{ borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }} bgcolor={'#ececec'}>
        <Button onClick={() => {
          navigate('validations');
        }} sx={{ margin: '8px' }} variant="contained" color="secondary2">Ver Agendamentos</Button>

      </Box>
    </Box>


  )

}
export default ValidationChart;